/*
|-------------------------------------------------------------------------------
| Vuex modules/savedSearch.js
|-------------------------------------------------------------------------------
| Vuex data store for saved search view
*/

import SavedSearchAPI from '@/api/savedSearch.js';
import { v4 as uuidv4 } from 'uuid';


export const savedSearch = {
    state: {
        // savedSearches: [],
        savedSearch: {
            tempId: Date.now(),
            created_at: "",
            id: 0,
            search_name: "",
            search_params: {},
            editing: false,
            searching: false,
            pivotData: []
        },
        // searchItem: 0,
        
    },
    actions: {
        // async getSavedSearches({ context }) {
        //     try {
        //       const { data } = await SavedSearchAPI.index();
        //       this.savedSearches = data.savedSearches.map((item) => {
        //         return {
        //           id: item.id,
        //           search_name: item.search_name,
        //           search_params: JSON.parse(item.search_params),
        //           created_at: item.created_at,
        //         };
        //       });
        //     } catch (error) {
        //       console.log(error);
        //     }
        //   }
    },
    mutations: {
        // setSavedSearches(state, payload) {
        //     state.savedSearches = payload;
        // },
        SET_SAVED_SEARCH(state, payload) {
            state.savedSearch = payload;
        },
        setSavedSearchId(state, payload) {
            state.savedSearch.id = payload;
        },
        SET_SEARCH_ITEM(state, payload) {
            state.searchItem = payload;
        }
    },
    getters: {
        getSavedSearch(state) {
            return state.savedSearch;
        },
        getSavedSearchId(state, getters) {
            return getters.getSavedSearch.id;
        },
        getSavedSearchParams(state, getters) {
            return getters.getSavedSearch.search_params || {};
        },
        getSavedSearchYears(state, getters) {
            return getters.getSavedSearchParams.years_h || [];
        },
        getSavedSearchMonths(state, getters) {
            return getters.getSavedSearchParams.months_h || [];
        },
        getSavedSearchProducts(state, getters) {
            return getters.getSavedSearchParams.products_h || [];
        },
        getSavedSearchCountries(state, getters) {
            return getters.getSavedSearchParams.country_h || [];
        },
        getSavedSearchMeasurements(state, getters) {
            return getters.getSavedSearchParams.measurement || [];
        },
    },
};
